import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Context } from "../../context/Context";
import { toast } from "react-toastify";
import axios from "axios";
import "./admin.css";
import { jwtDecode } from "jwt-decode";

const UnauthorizedComponent = () => (
  <div style={{ textAlign: "center", paddingTop: "100px", fontSize: "18px" }}>
    Not Authorized!
  </div>
);

const StatCard = ({ label, value }) => (
  <div style={{
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "20px",
    textAlign: "center",
    backgroundColor: "#f9f9f9"
  }}>
    <h3 style={{ margin: "0 0 10px", fontSize: "18px" }}>{label}</h3>
    <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>{value}</p>
  </div>
);

export default function Admin() {
  const { user, token } = useContext(Context);
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(null);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (!user || !token) {
      navigate("/login");
    }

    try {
      const userRole = Number(jwtDecode(token)?.role);
      setIsAuthorized(userRole > 4);
    } catch (err) {
      console.error("Invalid token", err);
      setIsAuthorized(false);
    }
  }, [user, token, navigate]);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get("/admin/summary", {
          headers: { Authorization: `Bearer ${token}` }
        });
        setStats(res.data);
      } catch (err) {
        console.error("Failed to fetch admin stats:", err);
        toast.error("Could not load dashboard data.");
      }
    };

    if (isAuthorized) {
      fetchStats();
    }
  }, [isAuthorized, token]);

  if (!isAuthorized) {
    return <UnauthorizedComponent />;
  }

  return (
   <>
    <div className="Admin">
      <div className="admin">
        <div
          className="write-title"
          style={{ position: "relative", display: "flex", alignItems: "center", gap: "40px" }}
        >
          <p
            style={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              margin: 0,
            }}
          >
            Admin Dashboard
          </p>
        </div>
        <div className="admin-body">
          
          {stats ? (
            <div className="admin-stats-grid" style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
              gap: "40px",
              margin: "40px"
            }}>
              <StatCard label="Total Articles" value={stats.totalArticles} />
              <StatCard label="Total Users" value={stats.totalUsers} />
              <StatCard label="Total Readers" value={stats.totalReaders} />
              <StatCard label="Total Writers" value={stats.totalWriters} />
              <StatCard label="Total Editors" value={stats.totalEditors} />
              <StatCard label="Total Admins" value={stats.totalAdmins} />
              <StatCard label="Total Super Admins" value={stats.totalSuperAdmins} />
              <StatCard label="Pending Reviews" value={stats.pendingReviews} />
              <StatCard label="Published This Week" value={stats.publishedThisWeek} />
            </div>
          ) : (
            <p>Loading stats...</p>
          )}
        </div>
      </div>
    </div>
   </>
  );
}
